import { mapActions, mapGetters, mapState } from 'vuex';
import purchaseOfferSushi from '@/components/purchase/sushi/purchase-offer-sushi/purchase-offer-sushi';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import purchaseTradeTypeSwitcherSushi from '@/components/purchase/sushi/purchase-trade-type-switcher-sushi/purchase-trade-type-switcher-sushi.vue';
import buttonPrice from '@/components/market/v2/button-price/button-price.vue'
import marketDisabledOutcomeV2
  from '@/components/market/v2/market-disabled-outcome-v2/market-disabled-outcome-v2.vue'
import {
  OPERATIONS,
  VALUES,
  BUTTONS,
} from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi.js'
import purchaseExtendedBetslip
  from '@/components/purchase/sushi/purchase-extended-betslip/purchase-extended-betslip.vue';
import { contractOwnershipNum } from '@/utils/helpers';
import scrollTo from '@/utils/scrollTo';


export default {
  mixins: [
    purchaseOfferSushi,
  ],
  components: {
    marketDisabledOutcomeV2,
    buttonPrice,
    marketCharts,
    purchaseTradeTypeSwitcherSushi,
    purchaseExtendedBetslip,
  },
  data() {
    return {
      activeButton: BUTTONS.BUY_YES.id,
      BUTTONS,
      OPERATIONS,
      VALUES,
    }
  },
  watch: {
    'tradeOperationAndValue' (v) {
      if (this.contract.contractId !== this.tradeOptions.contractId) return;
      const { type, value } = v;
      if (type && value) {
        this.activeButton = value === VALUES.YES ? BUTTONS.BUY_YES.id : BUTTONS.BUY_NO.id;
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled']),
    ...mapState('trade', ['tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode']),
    ...mapState('user', ['status']),
    chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId]
      }
    },
    mainClassName() {
      return 'purchase-offer-desktop-sushi-common-betslip';
    },
    classModifiers() {
      return {
        [this.mainClassName]: true,
        [`${this.mainClassName}--maintenance`]: !this.isTradingEnabled,
        [`${this.mainClassName}--yes`]: this.tradeOptions.operationValue === 'yes',
        [`${this.mainClassName}--no`]: this.tradeOptions.operationValue === 'no',
        [`${this.mainClassName}--${this.$router.currentRoute.name}`]: true,
      };
    },
    leftButtonText() {
      return this.activeButton === BUTTONS.BUY_YES.id ? 'Trade YES' : 'YES';
    },
    rightButtonText() {
      return this.activeButton === BUTTONS.BUY_NO.id ? 'Trade NO' : 'NO';
    },
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'toggleTradeOperation']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('market', ['pushSessionHistoryContract']),
    isButtonActive(index) {
      const isOn = this.activeButton === index;
      const isButtonActive = (this.tradeOptions.contractId === this.contract.contractId);

      return {
        'purchase-offer-desktop-sushi-common-betslip__button-single--active': isButtonActive,
        'purchase-offer-desktop-sushi-common-betslip__button-single--on': isOn,
        'purchase-offer-desktop-sushi-common-betslip__button-single--off': !isOn,
        'purchase-offer-desktop-sushi-common-betslip__button-single--off-yes': (this.tradeOptions.operationValue === VALUES.YES),
        'purchase-offer-desktop-sushi-common-betslip__button-single--off-no': (this.tradeOptions.operationValue === VALUES.NO),
      };
    },
    openPurchaseJourney(
      contractId, operationType, operationValue,
    ) {
      if (this.isWaiting) {
        return;
      }

      this.isWaiting = false;
      if (this.forCmsWidget) {
        this.$emit('contractClicked', { contractId });
        return;
      }
      if (this.isMarketSettled) return;
      if (this.isMarketDisabled && contractOwnershipNum(this.contractModel) === 0) return;
      this.pushSessionHistoryContract({
        value: {
          ...this.contract,
          marketName: this.market.marketShortName || this.market.marketName
        }
      });
      this.setTradeOptions({
        contractId,
        operationType,
        operationValue: operationValue !== null ?
          operationValue :
          (this.contractModel.mode || VALUES.YES),
      });
      // if (this.isLayoutMobile && previousContractId !== null && (previousContractId !== contractId)) {
      //   setTimeout(() => {
      //     const $el = document.querySelector(`[data-contract-id="${contractId}"]`);
      //     if ($el === null) return;
      //     const destination = Math.max(0, $el.offsetTop);
      //     scrollTo(destination, 250, 'linear');
      //   }, 1000);
      // }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-desktop-sushi-common-betslip/purchase-offer-desktop-sushi-common-betslip.js